function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

import _JSXStyle from "styled-jsx/style";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Resize from 'react-resize-detector';

var ScrollContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ScrollContainer, _React$Component);

  var _super = _createSuper(ScrollContainer);

  function ScrollContainer() {
    var _this;

    _classCallCheck(this, ScrollContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      overflowTop: false,
      overflowBottom: false,
      overflowLeft: false,
      overflowRight: false
    };
    _this.container =
    /*#__PURE__*/
    React.createRef();
    return _this;
  }

  _createClass(ScrollContainer, [{
    key: "detectOverflow",
    value: function detectOverflow() {
      var _this$container$curre = this.container.current,
          clientHeight = _this$container$curre.clientHeight,
          clientWidth = _this$container$curre.clientWidth,
          scrollHeight = _this$container$curre.scrollHeight,
          scrollLeft = _this$container$curre.scrollLeft,
          scrollTop = _this$container$curre.scrollTop,
          scrollWidth = _this$container$curre.scrollWidth;
      this.setState({
        overflowTop: scrollTop > 0,
        overflowBottom: scrollHeight - scrollTop > clientHeight,
        overflowLeft: scrollLeft > 0,
        overflowRight: scrollWidth - scrollLeft > clientWidth
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.detectOverflow();
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames,
          _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          height = _this$props.height,
          theme = _this$props.theme,
          props = _objectWithoutProperties(_this$props, ["children", "className", "height", "theme"]);

      var _this$state = this.state,
          overflowTop = _this$state.overflowTop,
          overflowBottom = _this$state.overflowBottom,
          overflowLeft = _this$state.overflowLeft,
          overflowRight = _this$state.overflowRight;
      var classNames = classnames(className, 'scroll-container', 'position-relative', (_classnames = {}, _defineProperty(_classnames, theme.overflowTop, overflowTop), _defineProperty(_classnames, theme.overflowBottom, overflowBottom), _defineProperty(_classnames, theme.overflowLeft, overflowLeft), _defineProperty(_classnames, theme.overflowRight, overflowRight), _classnames));
      return (
        /*#__PURE__*/
        React.createElement("div", _extends({}, props, {
          className: "jsx-1947054415" + " " + (props && props.className != null && props.className || classNames || "")
        }),
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.container,
          style: {
            maxHeight: height,
            overflow: 'auto'
          },
          onScroll: function onScroll(e) {
            return _this2.detectOverflow(e.target);
          },
          className: "jsx-1947054415"
        }, children),
        /*#__PURE__*/
        React.createElement(Resize, {
          handleWidth: true,
          handleHeight: true,
          onResize: function onResize() {
            return _this2.detectOverflow();
          },
          className: "d-none"
        }),
        /*#__PURE__*/
        React.createElement("div", {
          className: "jsx-1947054415" + " " + 'container-shadow'
        }),
        /*#__PURE__*/
        React.createElement(_JSXStyle, {
          id: "1947054415"
        }, ".scroll-container.jsx-1947054415 .container-shadow.jsx-1947054415{box-shadow:none;content:\"\";display:block;top:0px;left:0px;bottom:0px;right:0px;pointer-events:none;position:absolute;z-index:990;}.scroll-container.overflow-right.jsx-1947054415 .container-shadow.jsx-1947054415{box-shadow:-8px 0 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-left.jsx-1947054415 .container-shadow.jsx-1947054415{box-shadow:8px 0 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-left.overflow-right.jsx-1947054415 .container-shadow.jsx-1947054415{box-shadow:8px 0 8px -8px rgba(0,0,0,0.25) inset,-8px 0 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-bottom.jsx-1947054415 .container-shadow.jsx-1947054415{box-shadow:0 -8px 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-bottom.overflow-right.jsx-1947054415 .container-shadow.jsx-1947054415{box-shadow:0 -8px 8px -8px rgba(0,0,0,0.25) inset,-8px 0 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-bottom.overflow-left.jsx-1947054415 .container-shadow.jsx-1947054415{box-shadow:0 -8px 8px -8px rgba(0,0,0,0.25) inset,8px 0 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-bottom.overflow-left.overflow-right.jsx-1947054415 .container-shadow.jsx-1947054415{box-shadow:0 -8px 8px -8px rgba(0,0,0,0.25) inset,8px 0 8px -8px rgba(0,0,0,0.25) inset,-8px 0 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-top.jsx-1947054415 .container-shadow.jsx-1947054415{box-shadow:0 8px 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-top.overflow-right.jsx-1947054415 .container-shadow.jsx-1947054415{box-shadow:0 8px 8px -8px rgba(0,0,0,0.25) inset,-8px 0 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-top.overflow-left.jsx-1947054415 .container-shadow.jsx-1947054415{box-shadow:0 8px 8px -8px rgba(0,0,0,0.25) inset,8px 0 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-top.overflow-left.overflow-right.jsx-1947054415 .container-shadow.jsx-1947054415{box-shadow:0 8px 8px -8px rgba(0,0,0,0.25) inset,8px 0 8px -8px rgba(0,0,0,0.25) inset,-8px 0 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-top.overflow-bottom.jsx-1947054415 .container-shadow.jsx-1947054415{box-shadow:0 8px 8px -8px rgba(0,0,0,0.25) inset,0 -8px 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-top.overflow-bottom.overflow-right.jsx-1947054415 .container-shadow.jsx-1947054415{box-shadow:0 8px 8px -8px rgba(0,0,0,0.25) inset,-8px 0 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-top.overflow-bottom.overflow-left.jsx-1947054415 .container-shadow.jsx-1947054415{box-shadow:0 8px 8px -8px rgba(0,0,0,0.25) inset,0 -8px 8px -8px rgba(0,0,0,0.25) inset,8px 0 8px -8px rgba(0,0,0,0.25) inset;}.scroll-container.overflow-top.overflow-bottom.overflow-left.overflow-right.jsx-1947054415 .container-shadow.jsx-1947054415{box-shadow:0 8px 8px -8px rgba(0,0,0,0.25) inset,8px 0 8px -8px rgba(0,0,0,0.25) inset,-8px 0 8px -8px rgba(0,0,0,0.25) inset,0 -8px 8px -8px rgba(0,0,0,0.25) inset;}"))
      );
    }
  }]);

  return ScrollContainer;
}(React.Component);

ScrollContainer.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  theme: PropTypes.shape({
    overflowTop: PropTypes.string,
    overflowBottom: PropTypes.string,
    overflowLeft: PropTypes.string,
    overflowRight: PropTypes.string
  })
};
ScrollContainer.defaultProps = {
  theme: {
    overflowTop: 'overflow-top',
    overflowBottom: 'overflow-bottom',
    overflowLeft: 'overflow-left',
    overflowRight: 'overflow-right'
  }
};
ScrollContainer.displayName = "ScrollContainer";
export { ScrollContainer as default };